import { useSyncExternalStore } from "react";
import { getAppearance, subscribeAppearance } from "./appearance.ts";

export function useAppearance() {
  return useSyncExternalStore(subscribeAppearance, getAppearance, getAppearance);
}
